import React, { useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { StatusHandler } from '../../../components'
import { fetchResource } from '../../../features/resource/slice'
import { DashboardResourceForm } from '../../dashboard-resources-form'

const DashboardResourceUpdate = ({match, ...props}) => {
  const id = match.params.id
  const dispatch = useDispatch()
  const status = useSelector(state => state.resource.status)
  const error = useSelector(state => state.resource.error)

  const handleFetchResource = useCallback(() => {
    if(id){
      dispatch(fetchResource(id))
    }
  }, [dispatch, id])

  useEffect(() => {
    const isNeedInitialForm = match && match.params.id
    if(isNeedInitialForm){
      handleFetchResource()
    }
    //eslint-disable-next-line
  }, [])

  return (
    <StatusHandler
      status={status}
      error={error}
      onRetry={() => handleFetchResource()}
    >
      <DashboardResourceForm isEdit={true} {...props}/>
    </StatusHandler>
  )
}

export default DashboardResourceUpdate
